<template>
	<div class="grain"></div>
	<div class="vignette"></div>
	<CustomCursor />

	<div id="app">
		<Header />
		<router-view :key="$route.path" />
	</div>

	<div class="corner-item left">
		<SpeakerButton
			:is-playing="isPlaying"
			@toggle="toggleSound"
		/>
	</div>
	<div class="corner-item right">
		<a
			href="#"
			class="mamba-mark"
			aria-label="Mamba Dynamic"
			@click.prevent
			><img
				src="./assets/images/LOGO-MAMBA-WHITE.png"
				alt="Mamba Dynamic"
		/></a>
	</div>

	<YoutubePlayer
		ref="youtubePlayer"
		playlistId="PLOyeP6T2aEu37cYcnVFOMJPm_fSe2vOca"
		@state-change="isPlaying = $event"
	/>
</template>

<script>
import Header from '@/components/header/Header';
import YoutubePlayer from '@/components/YoutubePlayer.vue';
import CustomCursor from '@/components/CustomCursor.vue';
import SpeakerButton from '@/components/SpeakerButton.vue';

export default {
	name: 'App',
	components: {
		Header,
		YoutubePlayer,
		CustomCursor,
		SpeakerButton,
	},
	data() {
		return {
			isPlaying: false,
		};
	},
	methods: {
		toggleSound() {
			this.$refs.youtubePlayer.toggle();
		},
	},
};
</script>

<style>
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: var(--ink);
	min-height: 100vh;
	width: 100vw;
}

.corner-item {
	position: fixed;
	z-index: 30;
	bottom: 32px;
}
.corner-item.left {
	left: 48px;
}
.corner-item.right {
	right: 48px;
}

.mamba-mark img {
	height: 60px;
	width: auto;
	opacity: 0.85;
	transition: opacity 0.3s ease;
}
.mamba-mark:hover img {
	opacity: 1;
}

@media (max-width: 900px) {
	.corner-item.left {
		left: 24px;
		bottom: 24px;
	}
	.corner-item.right {
		right: 24px;
		bottom: 24px;
	}
	.mamba-mark img {
		height: 44px;
	}
}
</style>
